import styled, { css } from 'styled-components';
import { outlineTemplate } from '@equinor/eds-utils';

var BaseInputWrapper = styled.span.withConfig({
  displayName: "Switchstyles__BaseInputWrapper",
  componentId: "sc-x39lde-0"
})(function (_ref) {
  var _ref$theme = _ref.theme,
    width = _ref$theme.width,
    height = _ref$theme.height;
  return css(["width:", ";height:", ";border-radius:50%;position:relative;grid-area:input;"], width, height);
});
var BaseInput = styled.input.attrs(function (_ref2) {
  var _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'checkbox' : _ref2$type;
  return {
    type: type
  };
}).withConfig({
  displayName: "Switchstyles__BaseInput",
  componentId: "sc-x39lde-1"
})(function (_ref3) {
  var disabled = _ref3.disabled,
    theme = _ref3.theme;
  return css(["appearance:none;width:100%;height:100%;grid-area:input;margin:0;position:relative;z-index:1;cursor:", ";&:focus{outline:none;}&[data-focus-visible-added]:focus + span{", "}&:focus-visible + span{", "}"], disabled ? 'not-allowed' : 'pointer', outlineTemplate(theme.states.focus.outline), outlineTemplate(theme.states.focus.outline));
});
var GridWrapper = styled.span.withConfig({
  displayName: "Switchstyles__GridWrapper",
  componentId: "sc-x39lde-2"
})(["display:inline-grid;vertical-align:middle;grid:[input] 1fr / [input] 1fr;place-items:center;isolation:isolate;"]);

export { BaseInput, BaseInputWrapper, GridWrapper };
